module.exports = __webpack_public_path__ + "images/Cross_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Cross_hover.png
// module id = 378
// module chunks = 0 1